export default __webpack_public_path__ + "static/media/MontrealToQuebec.78ea3dc1.webp";